export default __webpack_public_path__ + "1bce3e4.png";